module.exports = __webpack_public_path__ + "img/hoshino_pc.1da1c09b.jpg";